import React from "react";
import { CheckCircle2 } from "lucide-react";

function WebhookFooter({isVerified,updatedAt}) {
  return (
    <div className="flex flex-col gap-2 border-t border-[#d8e7ed] bg-[#f8fbfc] px-4 py-3 sm:flex-row sm:items-center sm:justify-between sm:px-6 dark:border-dark-border dark:bg-dark-surface">

      {/* Status */}
      <div className="flex items-center gap-2">
        <CheckCircle2 size={14} className={isVerified ? "text-emerald-500" : "text-amber-500"}/>
        <span className="text-[9px] font-medium text-[#607787] dark:text-dark-text-secondary">
          {isVerified ? "Webhook is verified and ready to receive events." : "Webhook verification is required."}
        </span>
      </div>
      
      {/* Updated */}
      <span className="text-[8px] font-medium text-[#8194a0] dark:text-dark-text-muted">
        Updated {updatedAt}
      </span>
    </div>
  );
}

export default WebhookFooter;
